import { Injectable } from '@angular/core';
import { ConfigService, LoggingLevel } from '../config-service';
import { AppInsightsService } from '@markpieszak/ng-application-insights';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private _level: LoggingLevel = LoggingLevel.Warnings;
  private _printToConsole: boolean = false;

  constructor(config: ConfigService, private appInsightsService: AppInsightsService) {
    if (config.loggingLevel) {
      this._level = config.loggingLevel;
    }

    if (config.printToConsole) {
      this._printToConsole = config.printToConsole;
    }
  }

  log(
    message: any,
    level: LoggingLevel = LoggingLevel.Warnings,
    optionalParams: {
      [name: string]: string;
    },
  ) {
    if (this.shouldLog(level)) {
      switch (level) {
        case LoggingLevel.Errors:
          if (this._printToConsole) {
            console.error(message, optionalParams);
          }
          this.appInsightsService.trackException(message, null, optionalParams);
          break;
        case LoggingLevel.Warnings:
          if (this._printToConsole) {
            console.warn(message, optionalParams);
          }
          this.appInsightsService.trackEvent(message);
          break;
        case LoggingLevel.Info:
          if (this._printToConsole) {
            // eslint-disable-next-line no-console
            console.log(message, optionalParams);
          }
          this.appInsightsService.trackEvent(message, optionalParams);
          break;
        default:
          if (this._printToConsole) {
            // eslint-disable-next-line no-console
            console.log(message, optionalParams);
          }
          this.appInsightsService.trackEvent(message);
      }
    }
  }

  error(
    message: any,
    optionalParams: {
      [name: string]: string;
    },
  ) {
    this.log(message, LoggingLevel.Errors, optionalParams);
  }

  warning(
    message: any,
    optionalParams: {
      [name: string]: string;
    },
  ) {
    this.log(message, LoggingLevel.Warnings, optionalParams);
  }

  info(
    message: any,
    optionalParams: {
      [name: string]: string;
    },
  ) {
    this.log(message, LoggingLevel.Info, optionalParams);
  }

  verbose(
    message: any,
    optionalParams: {
      [name: string]: string;
    },
  ) {
    this.log(message, LoggingLevel.Verbose, optionalParams);
  }

  private shouldLog(level: LoggingLevel) {
    if (this._level === LoggingLevel.None) {
      return false;
    } else if (this._level === LoggingLevel.Errors) {
      return level === LoggingLevel.Errors;
    } else if (this._level === LoggingLevel.Warnings) {
      return level === LoggingLevel.Errors || level === LoggingLevel.Warnings;
    } else if (this._level === LoggingLevel.Info) {
      return (
        level === LoggingLevel.Errors ||
        level === LoggingLevel.Warnings ||
        level === LoggingLevel.Info
      );
    } else {
      return true;
    }
  }
}
